module.exports = __webpack_public_path__ + "assets/events_travel_primary.a22f4530.svg";